import { action, ActionType } from "typesafe-actions";

import { IError } from "../../../../../../../../../redux/actions/errorHandlingAction";

import { IFlyerDetailPagePosition } from "../../../../../../../types/flyer-detail-data/flyer-detail-page-position/flyer-detail-page-position.interface";

import { FlyerDetailPagePositionForm } from "../types/flyer-detail-page-position-form.interface";

import { FlyerDetailPageFormPositionCategoriesActionType } from "./flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.actions";

export enum FlyerDetailPageFormPositionActions {
  FetchPosition = "FlyerDetailPagePosition/FetchPosition",
  FetchPositionSuccess = "FlyerDetailPagePosition/FetchPositionSuccess",
  FetchPositionFailure = "FlyerDetailPagePosition/FetchPositionFailure",

  Reset = "FlyerDetailPagePosition/Reset",

  SavePosition = "FlyerDetailPagePosition/SavePosition",
  SavePositionSuccess = "FlyerDetailPagePosition/SavePositionSuccess",
  SavePositionFailure = "FlyerDetailPagePosition/SavePositionFailure",
}

export const fetchPosition = (pagePositionId: number) =>
  action(FlyerDetailPageFormPositionActions.FetchPosition, pagePositionId);
export const fetchPositionFailure = (error: IError) =>
  action(FlyerDetailPageFormPositionActions.FetchPositionFailure, error);
export const fetchPositionSuccess = (position: IFlyerDetailPagePosition) =>
  action(FlyerDetailPageFormPositionActions.FetchPositionSuccess, position);

export const reset = () => action(FlyerDetailPageFormPositionActions.Reset);

export const savePosition = (changes: Partial<FlyerDetailPagePositionForm>) =>
  action(FlyerDetailPageFormPositionActions.SavePosition, changes);
export const savePositionFailure = (error: IError) =>
  action(FlyerDetailPageFormPositionActions.SavePositionFailure, error);
export const savePositionSuccess = (position: IFlyerDetailPagePosition) =>
  action(FlyerDetailPageFormPositionActions.SavePositionSuccess, position);

const actionCreators = {
  fetchPosition,
  fetchPositionFailure,
  fetchPositionSuccess,

  reset,

  savePosition,
  savePositionFailure,
  savePositionSuccess,
};

export type FlyerDetailPageFormPositionActionType =
  | FlyerDetailPageFormPositionCategoriesActionType
  | ActionType<typeof actionCreators>;
